/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  FeatureServices,
  SharedFeatureService,
} from '@feature-hub/core';
import { HistoryServiceV3 } from '@feature-hub/history-service';
import { History } from 'history';
import { contentTracking, Content } from '@mtnkente/gtm';

export interface NavigationServiceV1 {
  readonly history: History;
  navigateTo(name: string, params?: Record<string, any>): string;
}

export interface SharedNavigationService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<NavigationServiceV1>;
}

export interface NavigationServiceDependencies extends FeatureServices {
  readonly 's2:history': HistoryServiceV3;
}

export function createSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-/]/g, '');
}

export const navigationServiceDefinition: FeatureServiceProviderDefinition<
  SharedNavigationService,
  NavigationServiceDependencies
> = {
  id: 'shell:navigation-service',
  dependencies: {
    featureServices: {
      's2:history': '^3.0.0',
    },
  },

  create: ({ featureServices }) => {
    const history = featureServices['s2:history'].rootHistory;
    return {
      '1.0.0': () => ({
        featureService: {
          history,
          navigateTo(name: string, params?: Record<string, any>): string {
            // test events
            contentTracking(
              new Content({
                eventName: 'buttonClick',
                eventDescription: 'User clicked on Create button',
                eventTrigger: 'button_click',
                category: 'Navigation',
                subcategory: 'create',
                title: 'Create Button ',
                description: `User initiated Create ${name}`,
              })
            );

            const defaultRoute = 'read';
            const slug = createSlug(name);
            const queryParams = params ? `?${new URLSearchParams(params)}` : '';
            const url = `/${defaultRoute}${slug}${queryParams}`;
            history.push({ pathname: url });
            const originalPush = history.push;
            history.push = (HistoryUrl, state) => {
              originalPush(HistoryUrl, state);
            };
            return url;
          },
        },
      }),
    };
  },
};
